import { takeEvery } from 'redux-saga'
import { put, call, select } from 'redux-saga/effects'
import { createFloorPlanSelector } from 'selectors'
import { addFloorPlanAction } from 'actions/floorPlanActions'
import chooseNextProperId from 'helpers/chooseNextProperId'
import determineLocationOfNewFloorPlan from 'helpers/floorPlans/determineLocationOfNewFloorPlan'
import { CREATE_FLOOR_PLAN } from 'actions/floorPlanActionTypes'
import { notifyHoneybadgerAction } from 'actions/applicationActions'

/** Add a floorPlan and then switch to it */
export function* createFloorPlan(action) {
  try {
    const { floorPlanIds, map } = yield select(createFloorPlanSelector)
    const id = yield call(chooseNextProperId, floorPlanIds)
    const { imageSrc, imageSize } = action
    const location = yield call(determineLocationOfNewFloorPlan, { map, imageSize })

    yield put(addFloorPlanAction(id, imageSrc, imageSize, location))
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for create floorPlan action, then call function */
export function* watchCreateFloorPlan() {
  yield* takeEvery(CREATE_FLOOR_PLAN, createFloorPlan)
}



// WEBPACK FOOTER //
// ./src/sagas/createFloorPlanSaga.js